import { TimeRange } from "../types"

export const isDayInRange = (day: moment.Moment, range?: TimeRange): boolean => {
    if(!range) return true
    
    let isAfter = true
    let isBefore = true 

    if(range.min) isAfter = day.isSameOrAfter(range.min, 'day')
    if(range.max) isBefore = day.isSameOrBefore(range.max, 'day')

    return isAfter && isBefore
}